// extracted by mini-css-extract-plugin
module.exports = {"policyTitle":"ServerExpandedPolicy_policyTitle__i8rp5"};